// DS: DS6.1 - Checkbox Semantics, but in a toggle pill format
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React from 'react';
import { useListItem } from '../../common';
import MainToggle from '../../../../formControls/dsPresets/MainToggle';
import ListItemContent from '../../legos/ListItemContent';
import { setRefs } from '../../../../../utils/refHelpers';
const ListItemToggle = (unfilteredProps)=>{
    const _useListItem = useListItem(unfilteredProps), { rootProps: { className, innerRef, checked, name, value }, contentProps, ref } = _useListItem, rest = _object_without_properties(_useListItem.rootProps, [
        "className",
        "innerRef",
        "checked",
        "name",
        "value"
    ]);
    return /*#__PURE__*/ React.createElement("label", {
        className: className,
        ref: (node)=>setRefs([
                ref,
                innerRef
            ], node)
    }, /*#__PURE__*/ React.createElement(ListItemContent, _object_spread_props(_object_spread({}, contentProps), {
        suffix: /*#__PURE__*/ React.createElement(MainToggle, _object_spread({
            /**
             * {@link CommonListItemProps}'s `label` prop is required, so we can safely mark this toggle as having an accessible
             * label.
             */ hasAccessibleLabel: true,
            name: name,
            value: !!checked
        }, rest))
    })));
};
ListItemToggle.displayName = 'ListItemToggle';
export default ListItemToggle;
